import {capitalize} from "@/helpers/capitalize";
import {useEffect} from "react";

const useFormErrorMutation = ([api, endpoint] = [], callback, deps) => {
    const [_, {isError, error} = {}] = api?.[`use${capitalize(endpoint)}Mutation`]?.({
        fixedCacheKey: `${endpoint}.form`
    }) ?? []

    useEffect(() => {
        if (isError && error) {
            callback(error)
        }
    }, [isError, error, ...deps]);
}

export default useFormErrorMutation;
